export default {"src":"https://search.testwiggot.com/_next/static/media/wiggot-x-monopolio.80b98868.svg","height":49,"width":270,"blurWidth":0,"blurHeight":0};